import "../../Stylesheets/Theme.sass";

import "./Modules/Effects.js";
import ContactFormPopup from "./Modules/ContactFormPopup.js";
import SeminarBookingForm from './Modules/SeminarBookingForm.js';

import ConsentManager from "./Modules/Vendor/ConsentManager.js";
import Modal from "./Modules/Vendor/Modal.js";
import Slider from "./Modules/Slider.js"; // TODO: Move to Vendor/...
import LazyLoader from './Modules/LazyLoader.js'; // TODO: Move to Vendor/...

document.addEventListener("DOMContentLoaded", () => {

    // Language
    const language = document.documentElement.getAttribute("lang");

    // Show
    document.documentElement.removeAttribute('data-hidden');

    // Delay Transitions
    setTimeout(() => {
        document.documentElement.removeAttribute('data-transitions');
    }, 1000);

    // LazyLoader
    new LazyLoader({
        delay: 25
    });

    // Consent Manager
    const consentManager = new ConsentManager(
        {
            interfaceLayout: ConsentManager.LAYOUT_CENTER,
            interfaceTheme: ConsentManager.THEME_LIGHT,
            interfaceMode: ConsentManager.MODE_ACCEPT_ALL_DENY_ALL,
            debug: false,
            privacyUri: '/datenschutzerklaerung',
            fingerprintIcon: false,
            disableFrames: false // TODO: This should actually be set
        },
        {
            0: {
                name: 'ga4',
                label: 'Tracking erlauben (Google Analytics)',
                uri: '/datenschutzerklaerung#google-analytics',
                enableScriptTag: true
            },
            2: {
                name: 'facebook',
                label: 'Tracking erlauben (Facebook)',
                uri: '/datenschutzerklaerung#facebook',
                enableScriptTag: true
            },
            3: {
                name: 'linkedin',
                label: 'Tracking erlauben (LinkedIn)',
                uri: '/datenschutzerklaerung#linkedin',
                enableScriptTag: true
            },
            4: {
                name: 'sendinblue',
                label: 'Cookies zulassen (Sendinblue)',
                uri: '/datenschutzerklaerung#sendinblue',
                enableScriptTag: true
            },
            5: {
                name: 'chat',
                label: 'Cookies zulassen (Chatfunktion)',
                uri: '/datenschutzerklaerung#sendinblue',
                enableScriptTag: true
            },
        }
    );

    // Init Footer (Logo) Slider
    const footerReferences = document.getElementById('footer__references')?.querySelector('.slider')
    if (footerReferences) {
        new Slider(footerReferences, {
            debug: false,
            controls: false,
            itemsPerView: 'auto',
            autoplay: true,
            autoplayInterval: 2500,
            mode: 'slide',
            slideContinously: true,
            gestures: false
        });
    }

    // Init Default Sliders
    const sliders = document.querySelectorAll('#content .slider');
    sliders.forEach(slider => {
        if (slider === footerReferences) {
            return;
        }
        new Slider(slider, {
            autoplay: true,
            controls: true,
            index: true,
            itemSelector: '.slider__item',
            debug: false,
            slideMode: 'rotate',
            autoplayInterval: 5000
        });
    });

    // Contact Form Popup
    new ContactFormPopup();

    // (New) Seminar Booking Form
    new SeminarBookingForm();

    // Seminaranmeldung: Abweichender Anmelder
    // TODO: begin DEPRECATED
    const additionalContactFieldset = document.querySelector('#seminar-details .additional-contact');
    let additionalContactCopyButton;
    if (additionalContactFieldset) {
        const toggleCheckbox = additionalContactFieldset.querySelector('input[type="checkbox"]');
        const toggleFieldWraps = additionalContactFieldset.querySelectorAll('.easyform-field-wrap.text:not([id*="5fa"]), .easyform-field-wrap.textarea');
        const copyFromFieldWraps = document.querySelectorAll('#seminar-details .primary-contact .easyform-field-wrap.text:not([id*="5fa"]), #seminar-details .primary-contact .easyform-field-wrap.textarea');
        toggleCheckbox.addEventListener('change', () => {
            for (const toggleFieldWrap of toggleFieldWraps) {
                toggleFieldWrap.style.display = toggleCheckbox.checked ? 'block' : 'none';
            }
            if (additionalContactCopyButton) additionalContactCopyButton.style.display = toggleCheckbox.checked ? 'inline-block' : 'none';
            if (toggleCheckbox.checked && !additionalContactCopyButton) {
                additionalContactCopyButton = document.createElement('button');
                additionalContactCopyButton.textContent = 'Kopieren / Copy';
                additionalContactCopyButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    for (const index in copyFromFieldWraps) {
                        if (typeof copyFromFieldWraps[index] === 'object') {
                            const copyValue = copyFromFieldWraps[index].querySelector('input, textarea').value;
                            if (copyValue && typeof toggleFieldWraps[index] === 'object') {
                                toggleFieldWraps[index].querySelector('input, textarea').value = copyValue;
                            }
                        }
                    }
                });
                toggleCheckbox.parentNode.parentNode.appendChild(additionalContactCopyButton);
            }
        });
        toggleCheckbox.dispatchEvent(new Event('change'));
    }
    // TODO: end DEPRECATED

    // Flyout
    const flyout = document.getElementById('header__flyout');
    setTimeout(() => {
        flyout.classList.remove('-hover');
    }, 2000);

    // Form Framework Checkbox Links
    document.querySelectorAll('form .input.checkbox label > span')?.forEach(checkboxLabel => {
        const link1 = document.createElement('a')
        link1.textContent = 'Anmeldebedingungen'
        if (document.body.id === 'page-2137') {
            link1.href = 'fileadmin/user_upload/Forum_Maschinenbau/2025/AGB_ForumMB.pdf.pdf'
        }
        else {
            link1.href = 'fileadmin/user_upload/aktuell/pdf/forum-technisches_training/Anmeldebedingungen-Forum.pdf'
        }
        link1.target = '_blank'
        link1.classList.add('inline')
        checkboxLabel.innerHTML = checkboxLabel.innerHTML.replace(new RegExp('Anmeldebedingungen'), link1.outerHTML)
        const link2 = document.createElement('a')
        link2.textContent = 'Datenschutzhinweise'
        link2.href = '/datenschutzerklaerung'
        link2.target = '_blank'
        link2.classList.add('inline')
        checkboxLabel.innerHTML = checkboxLabel.innerHTML.replace(new RegExp('Datenschutzhinweise'), link2.outerHTML)
    })

    // Search
    document.querySelectorAll('.tx-indexedsearch-searchbox [type="text"]')?.forEach(searchInput => {
        searchInput.placeholder = 'en' === language ? 'Search' : 'Suche'
    })

    // Chat
    window.focus()
    window.addEventListener('blur', () => {
        setTimeout(() => {
            if (document.activeElement.tagName === "IFRAME" && document.activeElement.classList.contains('brevo-conversations__iframe')) {
                document.getElementById('brevo-conversations').classList.add('-active')
            }
        })
    }, { once: true })

    // New popup CType feature
    const modal = new Modal({
        appendToBody: true
    });
    modal.popup('.popup', 24, 1000);

    // ###################################
    // Friendly Captcha Browser Validation
    // ###################################

    const friendlyCaptcha = document.querySelector('.frc-captcha');
    if (friendlyCaptcha) {
        const friendlyCaptchaProtectedForm = friendlyCaptcha.closest('form');
        let friendlyCaptchaCompleted = false;
        friendlyCaptchaProtectedForm.addEventListener('submit', (e) => {
            if (!friendlyCaptchaCompleted) {
                friendlyCaptcha.style.border = 'solid 1px red';
                e.preventDefault();
            }
        });
        friendlyCaptcha.addEventListener('frc:widget.complete', (e) => {
            friendlyCaptcha.style.border = 'none';
            friendlyCaptchaCompleted = true;
        });
    }

})